
import { TableHeader } from '../DataTable';
import { ReactComponent as AscendingIcon } from '../../../assets/Icons/arrows/arrow-up.svg';
import { ReactComponent as DescendingIcon } from '../../../assets/Icons/arrows/arrow-down.svg';
import { MouseEvent } from 'react';


export default function HeaderCell({ 
    header, 
    sorting,
}: {
    header: TableHeader,
    sorting?: {
        sortableHeaders: string[],
        sortHeaders: (e: MouseEvent<HTMLButtonElement>, value: string) => void,
        sortByParam: string | null,
        sortOrderParam: 'desc' | 'asc' | null,
    },
}) {


    return (
            <div className={`flex ${header.alignment === 'left' ? 'justify-start' : 'justify-center'} items-center gap-2 py-4 px-6 min-w-[150px]`}>
                {sorting && sorting.sortableHeaders.includes(header.value) ? (
                    <button 
                        className="font-semibold text-nowrap text-default text-[14px]" 
                        onClick={(e: MouseEvent<HTMLButtonElement>) => { e.preventDefault(); sorting.sortHeaders(e, header.value) }}
                    >
                        {header.label}
                    </button>
                ) : (
                    <p className="font-semibold text-nowrap text-default text-[14px]">{header.label}</p>
                )}
                {/* <p className="font-semibold text-nowrap text-default text-[14px]">{header.label}</p> */}
                {header.columnMetadata}

                {sorting && sorting.sortByParam === header.value && (
                    <>
                    {sorting.sortOrderParam === 'asc' ? (
                        <div className='w-[16px] text-default'><AscendingIcon /></div>
                    ) : (
                        <div className='w-[16px] text-default'><DescendingIcon /></div>
                    )}
                    </>
                )}
            </div>
    )
}